export class TicketHoldCommand {
    ticketId!: string;
    holder: string;
    holderEmail: string;
    comments: string;

   constructor(params: {
    ticketId: string;
    holder: string;
    holderEmail: string;
    comments: string;
  }) {
    this.ticketId = params.ticketId;
    this.holder = params.holder;
    this.holderEmail = params.holderEmail;
    this.comments = params.comments;
    }
}
